import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import { logo, eventName } from '../../config';
import { Container, Content, Background, AnimatedDiv2 } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import Logo from '../../components/Logo';
import Whatsapp from '../../components/Whatsapp';
import { useLanguage } from '../../hooks/Language';

interface SignInData {
  email: string;
  password: string;
  name: string;
}

const TranalhosNotificacao: React.FC = () => {
  

  return (
    <Container>
      <Content>
        <AnimatedDiv2>
        <h1>INSCRIÇÕES ABERTAS</h1>
        <a href="/apoio/trabalhos_cientificos.docx" target="_BLANK" download><Button>BAIXAR REGULAMENTO</Button></a>

        <a href="http://www.sptrs.org.br/enviar-trabalho" target="_BLANK" download><Button>ENVIAR TRABALHO</Button></a>
        </AnimatedDiv2>
      </Content>
    </Container>
  );
};
export default TranalhosNotificacao;
